const DocsQueryParams = {
  preview: 'preview',
  train: 'train',
  contentfulEnv: 'environment',
  unpublishedOas: 'oas-unpublished-id',
  legacyUnpublishedOas: 'unpublished',
};

export { DocsQueryParams };
